import PropTypes from "prop-types";

export default function VoteAwareProps() {
  return {
    votes: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired
  };
}
